import { PureComponent } from "react";
import classNames from "classnames";

interface Props {
    direction: "top"|"down";
}

export class Arrow extends PureComponent<Props> {
    public render() {
        return (
            <svg
                className={classNames(
                    { "icon-invert": this.props.direction === "top" },
                    "dark:fill-white",
                )}
                viewBox="0 0 20 20"
            >
                <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"></path>
            </svg>
        );
    }
}
